import React from "react";
import LearnMore from "../../../../../components/learnMore/learnMore";

const HeatmapLearnMore = () => {
  return <LearnMore title="Customer Retention Heatmap" content={getContent()} html />;
};

const getContent = () => {
  return `
          The heatmap shows exactly how many clients you are losing and when. Track new client engagement (up to 24 months) after their first visit. </br></br>
          <b>New Clients:</b> Total number of first time visits within the calendar month.</br>
          <b>Columns 1-24:</b> Months Active (the number of months a client has a purchase or a visit following the original visit/purchase based on cohort selected).</br></br>
          Filters -</br>
          <b>With ClassPass:</b> The default view, ClassPass attendees are included.</br>
          <b>Without ClassPass:</b> ClassPass attendees are excluded.</br>
          <b>Only ClassPass:</b> Only ClassPass attendees are calculated.</br>
          <b>Cross Regional Visits:</b> Include customers from other (brand specific) location.</br>
    `;
};

export default HeatmapLearnMore;
